<template>
  <div class="template-page">
    <NotFound v-if="isError" />

    <div v-else :class="{ container: !withoutContainer }">
      <HeadlineAction
        v-if="title"
        :title="title"
        :img="titleImg"
        class="template-page__title"
      />

      <div class="template-page__content" :class="{ 'last-child' : !isSeoContent }">
        <slot />
      </div>

      <div id="meta-content" :class="{ container: withoutContainer }">
        <SeoPageContent v-if="isSeoContent" class="template-page__desc" />

        <SeoTemplate
          v-if="seoTitle"
          :seo-title="seoTitle"
          :seo-description="seoDescription"
          :og-img-url="ogImgUrl"
          :twitter-img-url="twitterImgUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SeoPageContent from '@/components/shared/SeoPageContent'
import SeoTemplate from '@/components/shared/SeoTemplate'
import HeadlineAction from '@/components/shared/HeadlineAction'
const NotFound = () => import('@/components/NotFound')

export default {
  name: 'TemplatePage',
  components: {
    SeoTemplate,
    SeoPageContent,
    HeadlineAction,
    NotFound,
  },
  props: {
    title: { type: String },
    titleImg: { type: String },
    isSeoContent: { type: Boolean, default: true },
    seoTitle: { type: String },
    seoDescription: { type: String },
    ogImgUrl: { type: String },
    twitterImgUrl: { type: String },
    withoutContainer: { type: Boolean },
    noFetch: { type: Boolean, default: false },
    isError: { type: [Boolean, Error, Object] },
  },
}
</script>

<style lang="scss" scoped>
.template-page {
  position: relative;
  padding-bottom: var(--padding-3xl);
  padding-top: var(--padding-3xl);

  &__bread-top {
    padding-top: $spacer * 2;
    padding-bottom: $spacer * 4;

    @include media(tablet) {
      padding-top: $spacer * 4;
    }

    @include media(desktop) {
      padding-bottom: $spacer * 8;
    }
  }

  &__title {
    margin-bottom: var(--spaces-s);

    @include media(tablet) {
    margin-bottom: var(--spaces-m);
    }
  }

  &__content:not(.last-child) {
    margin-bottom: 32px;

    @include media(tablet) {
      margin-bottom: 64px;
    }
  }

  &__bread-bot {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
}
</style>
